export default __webpack_public_path__ + "static/rh-white-montserrat-v6-5dc935450d70b868f504b367236501ac.png";